// ------------------Atique----------------

import React, { useState, useEffect } from "react";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Table,
  Spinner,
} from "reactstrap";
import useGetAuthed from "../../helpers/hooks/useGetAuthed";

const LoanFinancials = () => {
  // STATES
  const { loanId, id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [financialData, setFinancialData] = useState([]);

  // HOOKS
  const [loanFinancialData, loanFinancialLoading] = useGetAuthed(
    `loan_financial/${loanId}`,
    true,
    "loan"
  );

  useEffect(() => {
    if (!loanFinancialLoading && loanFinancialData) {
      setFinancialData(loanFinancialData);
      setIsLoading(true);
    }
  }, [loanFinancialLoading, loanFinancialData, financialData]);

  const bankAdmin = JSON.parse(localStorage.getItem("bankAdmin"));

  const scrollToTable = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = -180; // Adjust this value as needed
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset + offset;
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    }
  };

  console.log("financial overall data ", loanFinancialData);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            {!isLoading ? (
              <div
                className="text-center"
                style={{ marginTop: "40px", marginLeft: "800px" }}
              >
                <Spinner className="mr-2" color="primary" />
              </div>
            ) : (
              <Col lg={12}>
                <Card style={{ borderRadius: "20px" }}>
                  <CardBody>
                    <div className="table-container">
                      <div className="row">
                        <div className="col-lg-12">
                          <h4
                            style={{ fontWeight: "bold", marginBottom: "20px" }}
                          >
                            {" "}
                            Bank Loan Financials - Summary
                          </h4>
                          <Table
                            bordered
                            responsive
                            style={{
                              marginBottom: "40px",
                            }}
                          >
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    backgroundColor: "#29aac5",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => scrollToTable("inputs")}
                                >
                                  <h6
                                    style={{
                                      color: "white",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Inputs
                                  </h6>
                                </th>
                                <th
                                  style={{
                                    backgroundColor: "#ea5f5f",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => scrollToTable("costofloan")}
                                >
                                  <h6
                                    style={{
                                      color: "white",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Cost of Loan
                                  </h6>
                                </th>
                                <th
                                  style={{
                                    backgroundColor: "#0eb748",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => scrollToTable("loanforfarmer")}
                                >
                                  <h6
                                    style={{
                                      color: "white",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Loan For Farmer
                                  </h6>
                                </th>
                                <th
                                  style={{
                                    backgroundColor: "#e3be22",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => scrollToTable("output")}
                                >
                                  <h6
                                    style={{
                                      color: "white",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Output
                                  </h6>
                                </th>
                                <th
                                  style={{
                                    backgroundColor: "#5f65ea",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => scrollToTable("farmerprofit")}
                                >
                                  <h6
                                    style={{
                                      color: "white",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Farmer Profit
                                  </h6>
                                </th>
                                {!bankAdmin && (
                                  <th
                                    style={{
                                      backgroundColor: "#18a07a",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      scrollToTable("farmerprofit")
                                    }
                                  >
                                    <h6
                                      style={{
                                        color: "white",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Beythak Margin
                                    </h6>
                                  </th>
                                )}
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <th>
                                  PKR{" "}
                                  {financialData.meta_data?.loan_input_total.toLocaleString(
                                    "en-US",
                                    { maximumFractionDigits: 0 }
                                  )}
                                </th>
                                <th>
                                  PKR{" "}
                                  {financialData.meta_data?.loan_cost_total.toLocaleString(
                                    "en-US",
                                    { maximumFractionDigits: 0 }
                                  )}
                                </th>
                                <th>
                                  PKR{" "}
                                  {financialData.data?.farmer_loan[0]?.[
                                    "Total Cost"
                                  ].toLocaleString("en-US", {
                                    maximumFractionDigits: 0,
                                  })}
                                </th>
                                <th>
                                  PKR{" "}
                                  {financialData.data?.loan_output[0]?.[
                                    "Total Price"
                                  ].toLocaleString("en-US", {
                                    maximumFractionDigits: 0,
                                  })}
                                </th>
                                <th>
                                  PKR{" "}
                                  {financialData.data?.farmer_financial[0]?.[
                                    "Profit"
                                  ].toLocaleString("en-US", {
                                    maximumFractionDigits: 0,
                                  })}
                                </th>
                                {!bankAdmin && (
                                  <th>
                                    PKR{" "}
                                    {financialData.meta_data?.beythak_margin_total.toLocaleString(
                                      "en-US",
                                      { maximumFractionDigits: 0 }
                                    )}
                                  </th>
                                )}
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                        <div className="col-lg-12">
                          <h4
                            style={{ fontWeight: "bold", marginBottom: "20px" }}
                          >
                            Input
                          </h4>

                          <Table
                            className="table table-bordered"
                            bordered
                            responsive
                            style={{ marginBottom: "40px" }}
                            id="inputs"
                          >
                            <thead>
                              <tr>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "188px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Category
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "180px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Brand
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "100px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Quantity
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "100px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Unit Price
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "100px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Total Price
                                  </h6>
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {financialData.data?.loan_input.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <th scope="row">{item.Category}</th>
                                    <td>{item.Brand}</td>
                                    <td>{item.Quantity}</td>
                                    <td>
                                      PKR{" "}
                                      {parseFloat(
                                        item["Unit Price"]
                                      ).toLocaleString("en-US", {
                                        maximumFractionDigits: 0,
                                      })}
                                    </td>
                                    <td>
                                      PKR{" "}
                                      {parseFloat(
                                        item["Total Price"]
                                      ).toLocaleString("en-US", {
                                        maximumFractionDigits: 0,
                                      })}
                                    </td>
                                  </tr>
                                )
                              )}
                              <tr>
                                <td
                                  colSpan="4"
                                  style={{ backgroundColor: "#f6fbfd" }}
                                >
                                  {" "}
                                  <h6 style={{ fontWeight: "bold" }}>
                                    {" "}
                                    Total Loan Value
                                  </h6>
                                </td>

                                <td style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      fontWeight: "bold",
                                      color: "#29aac5",
                                    }}
                                  >
                                    {" "}
                                    PKR{" "}
                                    {financialData.meta_data?.loan_input_total.toLocaleString(
                                      "en-US",
                                      {
                                        maximumFractionDigits: 0,
                                      }
                                    )}
                                  </h6>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>

                        <div className="col-lg-12">
                          <h4
                            style={{ fontWeight: "bold", marginBottom: "20px" }}
                          >
                            {" "}
                            Cost of Loan
                          </h4>
                          <Table
                            bordered
                            responsive
                            style={{ marginBottom: "40px" }}
                            id="costofloan"
                          >
                            <thead>
                              <tr>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      fontWeight: "bold",
                                      width: "220px",
                                    }}
                                  >
                                    Category
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "210px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Anual Interest%
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      fontWeight: "bold",
                                      width: "120px",
                                    }}
                                  >
                                    No. Of Months
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      fontWeight: "bold",
                                      width: "130px",
                                    }}
                                  >
                                    Prorated Interest
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      fontWeight: "bold",
                                      width: "130px",
                                    }}
                                  >
                                    Financial Value
                                  </h6>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {financialData.data?.loan_cost.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>{item.Category}</td>
                                    <td>{item["Annual Interest %"]}</td>
                                    <td>{item["No. of Months"]}</td>
                                    <td>{item["Prorated Interest"]}</td>
                                    <td>
                                      PKR{" "}
                                      {item["Financial Value"].toLocaleString(
                                        "en-US",
                                        {
                                          maximumFractionDigits: 0,
                                        }
                                      )}
                                    </td>
                                  </tr>
                                )
                              )}
                              <tr>
                                <td
                                  colSpan="4"
                                  style={{ backgroundColor: "#f6fbfd" }}
                                >
                                  <h6 style={{ fontWeight: "bold" }}>
                                    Total Output Value
                                  </h6>
                                </td>
                                {/* <td>Rs {financialData.meta_data?.loan_cost_total.toLocaleString("en-US", { maximumFractionDigits: 0 })}/-</td> */}
                                <td style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      fontWeight: "bold",
                                      color: "#ea5f5f",
                                    }}
                                  >
                                    {financialData.meta_data
                                      ?.loan_cost_total && (
                                      <h6
                                        style={{
                                          fontWeight: "bold",
                                          color: "#ea5f5f",
                                        }}
                                      >
                                        PKR{" "}
                                        {financialData.meta_data.loan_cost_total.toLocaleString(
                                          "en-US",
                                          { maximumFractionDigits: 0 }
                                        )}
                                      </h6>
                                    )}
                                  </h6>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                        <div className="col-lg-12">
                          <h4
                            style={{ fontWeight: "bold", marginBottom: "20px" }}
                          >
                            Loan For Farmer
                          </h4>
                          <Table
                            bordered
                            responsive
                            style={{ marginBottom: "40px" }}
                            id="loanforfarmer"
                          >
                            <thead>
                              <tr>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "245px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Input Cost
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "580px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Other Cost
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      fontWeight: "bold",
                                      width: "150px",
                                    }}
                                  >
                                    Total Cost
                                  </h6>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {financialData.data?.farmer_loan.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>
                                      PKR{" "}
                                      {item["Input Cost"].toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}
                                    </td>
                                    <td>
                                      PKR{" "}
                                      {item["Other Cost"].toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}
                                    </td>
                                    <td>
                                      {" "}
                                      <h6
                                        style={{
                                          fontWeight: "bold",
                                          color: "#0eb748",
                                        }}
                                      >
                                        PKR{" "}
                                        {item["Total Cost"].toLocaleString(
                                          "en-US",
                                          { maximumFractionDigits: 0 }
                                        )}
                                      </h6>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </Table>
                        </div>

                        <div className="col-lg-12">
                          <h4
                            style={{ fontWeight: "bold", marginBottom: "20px" }}
                          >
                            Output
                          </h4>
                          <Table
                            bordered
                            responsive
                            style={{ marginBottom: "40px" }}
                            id="output"
                          >
                            <thead>
                              <tr>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "270px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Crop
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "260px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Area(Acres)
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "160px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Est.Yield(Acres)
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "160px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Est.Unit Price
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "170px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {" "}
                                    Total Output Value
                                  </h6>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {financialData.data?.loan_output.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>{item["Crop"]}</td>
                                    <td>{item["Area(Acres)"]}</td>
                                    <td>
                                      {item["Est.Yield"].toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}
                                    </td>
                                    <td>PKR {item["Est.Unit Price"]}</td>
                                    <td>
                                      <h6
                                        style={{
                                          fontWeight: "bold",
                                          color: "#e3be22",
                                        }}
                                      >
                                        PKR{" "}
                                        {item["Total Price"].toLocaleString(
                                          "en-US",
                                          { maximumFractionDigits: 0 }
                                        )}
                                      </h6>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </Table>
                        </div>

                        <div className="col-lg-12">
                          <h4
                            style={{ fontWeight: "bold", marginBottom: "20px" }}
                          >
                            Farmer Profit
                          </h4>
                          <Table
                            bordered
                            responsive
                            style={{ marginBottom: "40px" }}
                            id="farmerprofit"
                          >
                            <thead>
                              <tr>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "150px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Output Value
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "170px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Cost Of Loan
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "180px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Cost of Output Sale
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6 style={{ fontWeight: "bold" }}>Profit</h6>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {financialData.data?.farmer_financial.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>
                                      PKR{" "}
                                      {item["Output Value"].toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}
                                    </td>
                                    <td>
                                      PKR{" "}
                                      {item["Cost of Loan"].toLocaleString(
                                        "en-US",
                                        { maximumFractionDigits: 0 }
                                      )}
                                    </td>
                                    <td>
                                      PKR{" "}
                                      {item[
                                        "Cost of Output sale"
                                      ].toLocaleString("en-US", {
                                        maximumFractionDigits: 0,
                                      })}
                                    </td>
                                    <td>
                                      <h6
                                        style={{
                                          fontWeight: "bold",
                                          color: "#5f65ea",
                                        }}
                                      >
                                        PKR{" "}
                                        {item["Profit"].toLocaleString(
                                          "en-US",
                                          { maximumFractionDigits: 0 }
                                        )}
                                      </h6>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </Table>
                        </div>

                        {!bankAdmin && <div className="col-lg-12">
                          <h4
                            style={{ fontWeight: "bold", marginBottom: "20px" }}
                          >
                            Beythak Margin
                          </h4>
                          <Table
                            bordered
                            responsive
                            style={{ marginBottom: "40px" }}
                            id="beythak"
                          >
                            <thead>
                              <tr>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "260px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Category
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      width: "230px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Share
                                  </h6>
                                </th>
                                <th style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6 style={{ fontWeight: "bold" }}>Value</h6>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {financialData.data?.beythak_margin.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>{item.Category}</td>
                                    <td>{item.Share}</td>
                                    <td>
                                      PKR{" "}
                                      {item.Value.toLocaleString("en-US", {
                                        maximumFractionDigits: 0,
                                      })}
                                      /-
                                    </td>
                                  </tr>
                                )
                              )}
                              <tr>
                                <td
                                  colSpan="2"
                                  style={{ backgroundColor: "#f6fbfd" }}
                                >
                                  <h6 style={{ fontWeight: "bold" }}>Total </h6>
                                </td>
                                <td style={{ backgroundColor: "#f6fbfd" }}>
                                  <h6
                                    style={{
                                      fontWeight: "bold",
                                      color: "#18a07a",
                                    }}
                                  >
                                    {financialData.meta_data
                                      ?.beythak_margin_total && (
                                      <>
                                        PKR{" "}
                                        {financialData.meta_data?.beythak_margin_total.toLocaleString(
                                          "en-US",
                                          { maximumFractionDigits: 0 }
                                        )}
                                      </>
                                    )}
                                  </h6>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>}
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default LoanFinancials;
